module.exports = __webpack_public_path__ + "img/location2.28c8e8ec.png";